// サブ設定フォームの JS 制御

document.addEventListener('turbolinks:load', function () {
  const MAX_SUB_SETTINGS = 5;
  const CIRCLED_NUMBERS = ['①', '②', '③', '④', '⑤'];
  const fieldsContainer = document.getElementById('sub-settings-fields');
  const addButton = document.getElementById('add-sub-setting');

  if (!fieldsContainer || !addButton) return;

  // 現在の表示件数を取得（_destroy が false のもの）
  function activeCount() {
    return fieldsContainer.querySelectorAll('.sub-setting-fields:not(.d-none)').length;
  }

  function updateButtonState() {
    addButton.disabled = activeCount() >= MAX_SUB_SETTINGS;
  }

  function renumber() {
    let i = 0;
    fieldsContainer.querySelectorAll('.sub-setting-fields').forEach(function (row) {
      const destroyInput = row.querySelector('.js-sub-setting-destroy');
      if (destroyInput && destroyInput.value === 'true') return;
      const title = row.querySelector('.sub-setting-title');
      if (title) title.textContent = 'サブ設定 ' + (CIRCLED_NUMBERS[i] || (i + 1));
      i++;
    });
  }

  // 会社コードのバリデーションと名前取得
  function fetchCompanyName(code, nameEl, required) {
    if (!code) {
      nameEl.textContent = required ? '該当する会社がありません' : '';
      return;
    }
    if (!/^\d{8}$/.test(code)) {
      nameEl.textContent = '該当する会社がありません';
      return;
    }
    fetch('/companies/code/' + encodeURIComponent(code) + '.json')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        nameEl.textContent = (data && data.name) ? data.name : '該当する会社がありません';
      })
      .catch(function () { nameEl.textContent = '該当する会社がありません'; });
  }

  // 削除リンクのイベント委譲
  fieldsContainer.addEventListener('click', function (e) {
    const removeBtn = e.target.closest('.js-remove-sub-setting');
    if (!removeBtn) return;
    e.preventDefault();

    const row = removeBtn.closest('.sub-setting-fields');
    const destroyInput = row.querySelector('.js-sub-setting-destroy');

    if (destroyInput) destroyInput.value = 'true';
    row.classList.add('d-none');

    renumber();
    updateButtonState();
  });

  // 追加ボタン
  addButton.addEventListener('click', function () {
    if (activeCount() >= MAX_SUB_SETTINGS) return;

    const newIndex = Date.now();
    const allRows = fieldsContainer.querySelectorAll('.sub-setting-fields');
    const lastRow = allRows[allRows.length - 1];

    let clone;
    if (lastRow) {
      clone = lastRow.cloneNode(true);

      // 入力値をクリア
      clone.querySelectorAll('input[type="text"]').forEach(function (input) {
        input.value = '';
      });
      clone.querySelectorAll('.js-sub-company-name, .js-sub-ec-company-name').forEach(function (el) {
        el.textContent = '';
      });

      // _destroy を false にリセット
      const destroyInput = clone.querySelector('.js-sub-setting-destroy');
      if (destroyInput) destroyInput.value = 'false';

      // data-record-id をクリア（新規レコードとして扱う）
      clone.dataset.recordId = '';

      // id hidden field をクリア（新規レコードとして扱う）
      const idField = clone.querySelector('input[type="hidden"][name*="[id]"]');
      if (idField) idField.value = '';

      // name/id の index 部分を更新
      clone.querySelectorAll('input, select, textarea').forEach(function (el) {
        ['name', 'id', 'for'].forEach(function (attr) {
          if (el.getAttribute(attr)) {
            el.setAttribute(attr, el.getAttribute(attr).replace(/\[\d+\]/, '[' + newIndex + ']'));
          }
        });
      });
    } else {
      // 既存行がない場合はテンプレートから生成
      const template = document.getElementById('sub-setting-template');
      if (!template) return;
      clone = template.content.cloneNode(true).querySelector('.sub-setting-fields');
      clone.querySelectorAll('[name], [id]').forEach(function (el) {
        if (el.getAttribute('name')) {
          el.setAttribute('name', el.getAttribute('name').replace(/NEW_INDEX/g, newIndex));
        }
        if (el.getAttribute('id')) {
          el.setAttribute('id', el.getAttribute('id').replace(/NEW_INDEX/g, newIndex));
        }
      });
    }

    clone.classList.remove('d-none');
    fieldsContainer.appendChild(clone);
    renumber();
    updateButtonState();

    attachCompanyCodeAjax(clone);
  });

  // 会社コード AJAX バインド
  function attachCompanyCodeAjax(container) {
    const companyCodeInput = container.querySelector('.js-sub-company-code-input');
    const companyNameEl = container.querySelector('.js-sub-company-name');
    const ecCodeInput = container.querySelector('.js-sub-ec-company-code-input');
    const ecNameEl = container.querySelector('.js-sub-ec-company-name');

    if (companyCodeInput && companyNameEl) {
      companyCodeInput.addEventListener('blur', function () {
        const code = this.value.trim();
        if (!code) { companyNameEl.textContent = ''; return; }
        fetchCompanyName(code, companyNameEl, true);
      });
    }

    if (ecCodeInput && ecNameEl) {
      ecCodeInput.addEventListener('blur', function () {
        const code = this.value.trim();
        if (!code) { ecNameEl.textContent = ''; return; }
        fetchCompanyName(code, ecNameEl, true);
      });
    }
  }

  // 既存データの初期表示
  fieldsContainer.querySelectorAll('.sub-setting-fields').forEach(function (row) {
    const companyCodeInput = row.querySelector('.js-sub-company-code-input');
    const companyNameEl = row.querySelector('.js-sub-company-name');
    const ecCodeInput = row.querySelector('.js-sub-ec-company-code-input');
    const ecNameEl = row.querySelector('.js-sub-ec-company-name');

    if (companyCodeInput && companyCodeInput.value && companyNameEl) {
      fetchCompanyName(companyCodeInput.value.trim(), companyNameEl, true);
    }
    if (ecCodeInput && ecCodeInput.value && ecNameEl) {
      fetchCompanyName(ecCodeInput.value.trim(), ecNameEl, true);
    }

    attachCompanyCodeAjax(row);
  });

  updateButtonState();
});
